/**
 * @desc 查询Details
 */

import fetch from '@/utils/request'
import config from '@/config'

export interface QueryParams {}

export function request(data: defs.AuthServiceIDParameter): Promise<BaseResponse<defs.ResultBean<defs.VersionControl>>> {
  return fetch({
    url: config.API_HOST + '/sys/appVersion/findVersionById',
    data: data,
    method: 'POST',
    credentials: 'include',
    timeout: 20 * 1000,
  })
}
